const $inject = ['$httpParamSerializer'];

const cdnService = function ($httpParamSerializer) {
  let service = {};

  service.imageResize = imageResize;

  function imageResize(args) {
    args.options = angular.extend(args.options, {
      mode: args.mode ? args.mode : 'crop',
      format: 'jpg',
      quality: 71
    });

    return args.imgPath + '?' + $httpParamSerializer(args.options);
  }

  return service;
};

cdnService.$inject = $inject;

export default cdnService;



// WEBPACK FOOTER //
// ./src/services/cdnService.js